module.exports = __webpack_public_path__ + "static/media/how-it-works@2x.3f7992e6.png";